import React, { useEffect, useState } from 'react';
import { ItemReference } from 'stores/dataStore';
import TailwindSelect from 'widgets/editors/tailwind-select';

interface MachineRelatedEditorProps {
  value: ItemReference;
  onChange?: (value: ItemReference) => void;
  placeholder?: string;
  clearable?: boolean;
  readOnly?: boolean;
  className?: string;
  nullable?: boolean;
  onBlur?: (event: React.FocusEvent) => void;
  onFocus?: (event: React.FocusEvent) => void;
}

const TailwindMachineRelatedEditor: React.FC<MachineRelatedEditorProps> = ({
  value,
  onChange,
  placeholder,
  clearable = true,
  readOnly = false,
  className = '',
  nullable = false,
  onBlur,
  onFocus
}) => {
  const [selectedValue, setSelectedValue] = useState<ItemReference>(value);
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

  const loadMachineRelatedOptions = () => {
    setOptions([
      { value: 'machine', label: 'Yes' },
      { value: 'nonMachine', label: 'No' }
    ]);
  };

  useEffect(() => {
    loadMachineRelatedOptions();
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleChange = (newValue: string | null) => {
    const selected = newValue ? options.find(opt => opt.value === newValue) : null;
    const itemRef = selected ? { id: selected.value, title: selected.label } : null;
    setSelectedValue(itemRef);
    onChange?.(itemRef);
  };

  return (
    <TailwindSelect
      options={options.map(opt => ({
        id: opt.value,
        text: opt.label
      }))}
      value={selectedValue?.id || ''}
      onChange={handleChange}
      placeholder={placeholder || 'Select an option'}
      clearable
      searchable
      className="w-full"
    />
  );
};

export default TailwindMachineRelatedEditor;
